export const keyLengthToKeyName = { 'Alpha-2': 'SHORT_COUNTRY_CODE', 'Alpha-3': 'COUNTRY_CODE' };
export const regionCodeName = 'code';
